import { API_BASE_URL } from '@/constants/env';
import { useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';

export function useJobApplyForm(job) {
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState();

  const captchaRef = useRef(null);
  const [captchaVerified, setCaptchaVerified] = useState(false);

  const onCaptchaExpire = () => {
    return toast.error('Captcha token has expired');
  };

  const onCaptchaError = (error) => {
    return toast.error(`Captcha error: ${error}`);
  };

  const onCaptchaVerify = (token) => {
    if (token) setCaptchaVerified(true);
  };

  const onSubmit = handleSubmit(async (data) => {
    // Check captcha
    if (!captchaVerified) return toast.error("Please proof that you're human");

    // Reset loading state
    setLoading(true);

    // Construct form data
    const formData = new FormData();
    formData.append('position', job.title);
    formData.append('firstName', data.firstName);
    formData.append('lastName', data.lastName);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    formData.append('motivation', data.motivation);
    formData.append('resume', data.resume[0]);
    if (data.additionalDocuments.length > 0) {
      [...data.additionalDocuments].forEach((file) => {
        formData.append('additionalDocuments', file);
      });
    }

    // Send API request
    try {
      const response = await fetch(API_BASE_URL.concat('/jobs/apply'), {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();
      if (data.error) {
        toast.error(data.error.message);
      } else if (data.success) {
        toast.success('Thank you for applying. You will be contacted for further information.', {
          duration: 5000,
        });
        reset();
      }
    } catch (ex) {
      toast.error(ex.message);
    } finally {
      setLoading(false);
      setCaptchaVerified(false);
      captchaRef.current?.resetCaptcha();
    }
  });

  return {
    register,
    errors,
    loading,
    onSubmit,
    captchaRef,
    onCaptchaExpire,
    onCaptchaError,
    onCaptchaVerify,
  };
}
